module.exports = __webpack_public_path__ + "media/images/affiliation_logos/affiliate_logo_alifaisal-daa6936fa0e411aaee923c450c129383.png";